import {Injectable} from '@angular/core';
import {
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    UrlTree,
    Router,
    CanActivate,
} from '@angular/router';
import {Observable} from 'rxjs';
import {getCookie} from '../shared/helpers/cookie';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard implements CanActivate {
    constructor(public router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot): boolean {
        // if (!localStorage.getItem('accessToken')) {
        //   (window as any).open('https://self.chaka.ng/login', '_self');
        //   return false;
        // } else {
        //   return true;
        // }

        if (!getCookie('accessToken')) {
            (window as any).open('https://self.chaka.ng/login', '_self');
            return false;
        } else {
            return true;
        }
    }
}
